import { render, staticRenderFns } from "./JobAdmin.vue?vue&type=template&id=b65764bc&scoped=true"
import script from "./JobAdmin.vue?vue&type=script&lang=js"
export * from "./JobAdmin.vue?vue&type=script&lang=js"
import style0 from "./JobAdmin.vue?vue&type=style&index=0&id=b65764bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65764bc",
  null
  
)

export default component.exports